const STORAGE_PREFIX = 'sidebarFavorites_';

export function getSidebarFavoritesStorageKey(userId) {
  if (!userId) {
    return null;
  }
  return `${STORAGE_PREFIX}${userId}`;
}

export function getSidebarFavorites(userId) {
  const key = getSidebarFavoritesStorageKey(userId);
  if (!key) {
    return [];
  }
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function saveSidebarFavorites(userId, favorites) {
  const key = getSidebarFavoritesStorageKey(userId);
  if (!key) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(favorites || []));
}

export function isSidebarFavorite(favorites, menuId) {
  return (favorites || []).some(item => item.menuId === menuId);
}

export function toggleSidebarFavorite(userId, favorites, favoriteEntry) {
  const list = favorites || [];
  const exists = list.some(item => item.menuId === favoriteEntry.menuId);
  let next;
  if (exists) {
    next = list.filter(item => item.menuId !== favoriteEntry.menuId);
  } else {
    next = [...list, favoriteEntry];
  }
  saveSidebarFavorites(userId, next);
  return next;
}
